import ShowocaseLayout from "../../../../components/layout/ShowocaseLayout";
import AsyncPage from "./async";
import React from "react";
import {Route} from "react-router-dom";

export default [
    <Route key="/business/showcase/beard-style" element={<ShowocaseLayout />}>
        <Route path="business/showcase/beard-style" element={<AsyncPage />} />
    </Route>,
];
